import React, { useEffect, useState } from "react";
import { DashboardDetailWrapper } from "./Styled";
import Title from "./Title";
import DashboardTabNavigation from "./TabBar";

const DashboardDetail = () => {
    return (
        <DashboardDetailWrapper>
            <Title title={"Tổng quan"} />
            <DashboardTabNavigation />
        </DashboardDetailWrapper>
    );
};

export default DashboardDetail;
